// extracted by mini-css-extract-plugin
export var audioPlayer = "_qp-0";